import type { paths } from "./api-schema";
export type ApiPaths = keyof paths;
export class ApiError extends Error {
  constructor(
    public code: string,
    message: string,
    public status: number,
  ) {
    super(message);
  }
}
const csrf = () =>
  document.cookie
    .split("; ")
    .find((v) => v.startsWith("ims_csrf="))
    ?.split("=")[1] || "";
let refreshing: Promise<Response> | null = null;
export async function api<T>(
  path: string,
  method = "GET",
  body?: unknown,
  retry = true,
): Promise<T> {
  const form = body instanceof FormData;
  const response = await fetch("/api/v1" + path, {
    method,
    credentials: "same-origin",
    headers: {
      ...(form ? {} : { "Content-Type": "application/json" }),
      "X-CSRF-Token": csrf(),
    },
    body: body === undefined ? undefined : form ? body : JSON.stringify(body),
  });
  if (response.status === 401 && retry && !path.startsWith("/auth/")) {
    refreshing ??= fetch("/api/v1/auth/refresh", {
      method: "POST",
      headers: { "X-CSRF-Token": csrf() },
    }).finally(() => {
      refreshing = null;
    });
    const refresh = await refreshing;
    if (refresh.ok) return api<T>(path, method, body, false);
  }
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new ApiError(
      data.code || "request_failed",
      data.message ||
        (response.status === 422
          ? "Проверьте заполнение полей"
          : "Не удалось выполнить действие"),
      response.status,
    );
  }
  return response.status === 204 ? (undefined as T) : response.json();
}
